const colors = {
  primary: '#5843E4',
  secondary: '#8186A0',
  backgroundLight: '#F9F9FC',
  backgroundDark: '#4F4C6B',
  dark: '#000000',
}

export default colors
